import React from "react";
import { lazy, Suspense } from "react";
import { EbPageLoader } from "../Common";

export default function Loadable() {
  const List = lazy(() => import("./Lists"));
  return (
    <Suspense fallback={<EbPageLoader />}>
      <List />
    </Suspense>
  );
}
